module.exports = __webpack_public_path__ + "img/locked expiring 2 days.b4726ae6.svg";